var map = {
	"./1024px-Republique-francaise-logo.svg.png": 3217,
	"./6zo.png": 4673,
	"./ENSEIGNE-ROBICHON-LASER-350-X-100.png": 6873,
	"./Logo Bar LE BIARD - 2 (1).jpg": 9866,
	"./Logo_Natsukaya.png": 6895,
	"./Mairie de Biard.png": 4634,
	"./bouchet frères.jpg": 5590,
	"./controle-auto-biard.png": 5887,
	"./crédita agricole.png": 4764,
	"./ici-poitou.png": 7570,
	"./logo Conseil départemental de la Vienne.jpg": 5191,
	"./logo Durand.jpg": 1465,
	"./logo Grand Poitiers.png": 3304,
	"./logo boulangerie de Biard.webp": 5017,
	"./logo resto Crispy.jpg": 9044,
	"./logo terrasses bois.png": 6464,
	"./logo_cluri_JZN_grand.jpg": 1833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8466;